var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotion-end",style:(_vm.backgroundColorStyle)},[_c('div',{staticClass:"prompt"},[_vm._v(_vm._s(_vm.prompt))])])}
var staticRenderFns = []

export { render, staticRenderFns }